<template>
<div class="teams-config">
    <h3 class="teams-config-title">{{$t('teams_apps.the_tab_is_configured')}}</h3>
    <span>{{$t('teams_apps.press_the_save_button_at_the_bottom_of_this_screen')}}</span>
</div>
</template>

<script>
import {app, pages} from "@microsoft/teams-js";

export default {
    name: "teams-config-tab-component",
    props: {
        contentUrlIn: {
            type: String,
            required: true,
        },
        uuidIn: {
            type: String,
            required: true,
        }
    },
    mounted() {
        app.initialize();
        this.submit();
    },

    methods:{
        submit() {
            app.getContext().then((success) => {
                const uuid = success.page.id ? success.page.id : this.uuidIn;

                pages.config.setValidityState(true);
                pages.config.registerOnSaveHandler((saveEvent) => {
                    pages.config.setConfig({
                        contentUrl: this.routes.baseUrl() + this.contentUrlIn,
                        suggestedDisplayName: 'SLU Dashboard',
                        entityId: uuid
                    }).then(
                        (result) => {
                            saveEvent.notifySuccess();
                        },
                        (error) => {
                            saveEvent.notifyFailure(this.$t('teams_apps.unexpected_error'))
                        }
                    )
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
    .teams-config-title {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
</style>
